import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.ui.touch-punch.min';
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.i18n';
import filter from '@PROJECT_ROOT/assets/mobile/js/filterResults';

export default function initFilter(state) {
    const $priceFrom = $(`#${state.priceFromId}`);
    const $priceTo = $(`#${state.priceToId}`);

    filter.init({
        resultsCountUrl: state.resultsCountUrl,
        searchResultsURL: state.searchResultsURL,
        sliderElem: $('#slider'),
        priceInputs: [
            $priceFrom,
            $priceTo,
        ],
        sliderMax: $priceTo.data('maxValue'),
        formIds: {
            accommodationType: state.accommodationTypeId,
            airConditioning: state.airConditioningId,
            arrival: state.arrivalId,
            beachDistance: state.beachDistanceId,
            beachType: state.beachTypeId,
            bedrooms: state.bedroomsId,
            category: state.categoryTypeId,
            departure: state.departureId,
            discounts: state.discountTypeId,
            land: state.landTypeId,
            location: state.locationId,
            location_id: state.locationIdId,
            latitude: state.latitudeId,
            longitude: state.longitudeId,
            nearMe: state.nearMeId,
            outerViewSea: state.outerViewSeaId,
            parking: state.parkingId,
            persons: state.personsId,
            distribution: state.multipleUnitsAllowedId,
            petsAllowed: state.petsId,
            pool: state.poolId,
            moor: state.moorId,
            food: state.foodTypeId,
            priceFrom: state.priceFromId,
            priceTo: state.priceToId,
            wifi: state.wifiId,
            neLat: state.neLatId,
            neLng: state.neLngId,
            swLat: state.swLatId,
            swLng: state.swLngId,
            radius: state.placeRadiusId,
            deviation: state.deviationId,
        },
    });
}
